import React, { Component} from 'react';
import AtozLinks from './atozLinks';
import GAToZLoader from './gatozLoader';
class AccelleratedMasters extends Component {
 
  renderMenu() {
    let usedLetters = [];
    let items = this.props.data.filter(function(item) {
      return typeof item.field_link2 !== "undefined";
    });
    let currentLetter = "A";
    let outerCount = 0;
    items.forEach(function(item) {
      let firstLetter = item.field_link2.title.charAt(0);
      if (firstLetter === currentLetter && outerCount === 0) {
        usedLetters[outerCount] = currentLetter;
        outerCount++;
      } else if(firstLetter !== currentLetter) {
        usedLetters[outerCount]=firstLetter;
        currentLetter = firstLetter;
        outerCount++;
      }
    });
    usedLetters[outerCount] = "ac";
    return (
      <div className="letterMenu">
        <AtozLinks letters={usedLetters} /> 
      </div>
    );
  }

  renderItems() {
    let letterSort = [];
    for (let i = 0; i <= 25; i++) {
      letterSort[i] = [];
    }
    let currentLetter = "A";
    let innterCount = 0;
    let outerCount = 0;
    let items = this.props.data.filter(function(item) {
      return typeof item.field_link2 !== "undefined";
    });
    items.forEach(function(item) {
      let firstLetter = item.field_link2.title.charAt(0);
      if (firstLetter !== currentLetter) {
        currentLetter = firstLetter;
        innterCount = 0;
        outerCount++;
      }
      if (item.field_link2 !==null) {
        letterSort[outerCount][innterCount] = item;
        letterSort[outerCount][innterCount].currentLetter = currentLetter+'ac';
        letterSort[outerCount][innterCount].id = item.id;
        innterCount++;
      }
    });
  
    return (
      letterSort.map((item, i) => (
        <div key={i} className="AtoZDegrees">
          <GAToZLoader item={item} type="A" />  
        </div>
      ))
    );
  }

  render() {
    return(
      <div className="accellerated">
        <div className="title menu" style={{
          width: "100%",
          backgroundColor: "#fff",
          fontWeight: "bold"
        }}>
          {this.renderMenu()}
        </div>
        <div style={{
          padding: "10px",
          columnCount: window.innerWidth > 1100 ? "3" : window.innerWidth > 899 ? "2" : "1",
          float: window.innerWidth > 899 ? null : "left",
        }}>
          {this.renderItems()}
        </div>
      </div>
    );       
  }
}

export default AccelleratedMasters;
